export let LabelVariant = /*#__PURE__*/function (LabelVariant) {
  LabelVariant["Standard"] = "standard";
  LabelVariant["PrimaryLight"] = "primary-light";
  return LabelVariant;
}({});
//# sourceMappingURL=types.js.map